import { CardSelectionProps, CardSelectionStateProps } from '../../types/components/subscription-upgrade-modal/CardSelection';
import { StripePaymentMethodData } from '../../types/api/stripe/paymentMethod';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import paymentMethodHelpers from '../../helpers/subscriptionPaymentMethods';

import { PaymentElement } from '@stripe/react-stripe-js';

const CardSelection: React.FC<CardSelectionProps> = ({
  subscription,
  onSavedCardLoaded,
}) => {
  const dispatch = useDispatch();
  const { fetchCurrentCardData } = paymentMethodHelpers;

  const [savedCard, setSavedCard] = useState<StripePaymentMethodData>();
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);

  const loadSavedCards = async () => {
    const savedCard = await fetchCurrentCardData(dispatch, subscription);
    setDataLoaded(true);
    if (!savedCard) return;
    setSavedCard(savedCard);
    onSavedCardLoaded(savedCard);
  }

  useEffect(() => {
    loadSavedCards();
  }, []);

  const renderNewCardInput = (): React.ReactElement => {
    return !savedCard && !!dataLoaded &&
    <div cy-test-id="add-card-form" className="w-full p-6 bg-a-dark-gray rounded-[5px]">
      <PaymentElement />
    </div>
  }

  return (
    <div className="w-full" cy-test-id="card-selection">
      {renderNewCardInput()}
    </div>
  );
};

const mapStateToProps = (state: ApplicationState): CardSelectionStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
});

export default connect(mapStateToProps)(CardSelection);
